import { render, staticRenderFns } from "./LeaveRequest.vue?vue&type=template&id=55d498b6"
import script from "./LeaveRequest.vue?vue&type=script&lang=js"
export * from "./LeaveRequest.vue?vue&type=script&lang=js"
import style0 from "./LeaveRequest.vue?vue&type=style&index=0&id=55d498b6&prod&lang=scss"
import style1 from "./LeaveRequest.vue?vue&type=style&index=1&id=55d498b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports